import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function MarketArrowUpIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M12 7.7002L19.6492 14.261C20.3537 14.8653 19.9264 16.02 18.9981 16.02L5.00173 16.0201C4.07349 16.0201 3.64611 14.8654 4.3507 14.261L12 7.7002Z",
    fill: "currentColor"
  }));
}